export class EditLibraryOptions {
    componentRegistryURL?: string;
    layoutDefinitionURL?: string;
    baseCompEntConfigSource?: string;
    allowDuplicateComponents: boolean;
    generateComponentId: boolean;
    allowedComponentActions: ComponentActions[];
}

export enum ComponentActions {
    EDIT = 'EDIT',
    REMOVE = 'REMOVE'
}
